import axios from "axios";
import { productSalesApiUrl, domainsListUrl } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

const config = (params = {}) => ({
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${getUserToken()}`,
    },
    params,
});

// params: fy, month, domain, categories (comma ids), search, order_type, statuses (comma list), sort, page, page_size
export const getProductSales = (params) => axios.get(productSalesApiUrl, config(params));

export const getProductSalesDetail = (sku, params) =>
    axios.get(`${productSalesApiUrl}/${encodeURIComponent(sku)}`, config(params));

export const getDomains = () => axios.get(domainsListUrl, config());

// [{id, name, domain_id}] for the Category filter
export const getCategories = () => axios.get(`${productSalesApiUrl}/categories`, config());

// Downloads the filtered Product Sales report (.xlsx, all products, no paging)
export const downloadProductSalesExcel = async (params) => {
    const res = await axios.get(`${productSalesApiUrl}/export`, { ...config(params), responseType: "blob" });
    const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1]
        || `Product_Sales_FY${params.fy}.xlsx`;
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

// One product's sales placed on the district map (pincode first, then typed district)
export const getProductSalesDistricts = (sku, params) =>
    axios.get(`${productSalesApiUrl}/${encodeURIComponent(sku)}/districts`, config(params));

// Several products added up: params.skus = "A,B,C" plus the usual filters
export const getProductSalesCombined = (params) => axios.get(`${productSalesApiUrl}/combined`, config(params));

export const getProductSalesCombinedDistricts = (params) =>
    axios.get(`${productSalesApiUrl}/combined/districts`, config(params));
